import { useNavigate } from 'react-router-dom';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import '../../css/SideBar.css';

export const NewSideBarItem = (props) => {
  let navigate = useNavigate();

  const routeChange = () => {
    let path = props.route;
    navigate(path);
  };

  return (
    <ListItem disablePadding sx={{ display: 'block' }}>
      <ListItemButton
        sx={{
          minHeight: 80,
          justifyContent: props.open ? 'initial' : 'center',
          px: 2.5,
          padding: props.open ? '30px' : '25px',
        }}
        selected={props.selected}
        onClick={routeChange}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: props.open ? 3 : 'auto',
            justifyContent: 'center',
          }}
        >
          {props.iconName}
        </ListItemIcon>
        <ListItemText
          primary={props.text}
          sx={{ opacity: props.open ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};
